var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isWindowExist } from './';
var LogModel = /** @class */ (function () {
    function class_1(buryCode, config) {
        var _a;
        this.name = '';
        this.inspectionPassed = true; // 是否检查通过？
        this.filterPoint = {};
        if (isWindowExist() === false) {
            return;
        }
        var diyWindow = __assign({ __userPoolId__: '-', __user__: { id: '-' } }, window);
        // 四段式
        this.site = (config === null || config === void 0 ? void 0 : config.defaultSite) || '-'; // todo，可以根据几个域名做字典映射
        this.page = (config === null || config === void 0 ? void 0 : config.defaultPage) || '-';
        this.block = (config === null || config === void 0 ? void 0 : config.defaultBlock) || '-';
        this.element = (config === null || config === void 0 ? void 0 : config.defaultElement) || '-';
        // 配置值 > window
        this.upid = (config === null || config === void 0 ? void 0 : config.defaultUserPoolId) || (diyWindow === null || diyWindow === void 0 ? void 0 : diyWindow.__userPoolId__) || '-';
        this.uid = (config === null || config === void 0 ? void 0 : config.defaultUserId) || ((_a = diyWindow === null || diyWindow === void 0 ? void 0 : diyWindow.__user__) === null || _a === void 0 ? void 0 : _a.id) || '-';
        this.expansionBlock = {}; // 拓展块，未来要兼容其他格式用的
        this.paserCode(buryCode);
        this.setName(); // 拼接埋点名字
    }
    class_1.prototype.paserCode = function (logString) {
        var _a = logString.split('?'), path = _a[0], queryBlock = _a[1];
        // 埋点字符串 格式校验
        if (!path) {
            console.warn('埋点解析错误，无法获取 path 块', logString);
            return;
        }
        // 读取 query 部分解析
        queryBlock && this.paserQuery(queryBlock);
        this.paserPath(path);
    };
    class_1.prototype.paserPath = function (path) {
        // 读取 path 部分解析
        var pathList = path.split('/');
        if (pathList.length === 1) {
            // 只有 block/element 两个块，隐含表示 page 是 index
            var e = pathList[0];
            this.element = e;
        }
        else if (pathList.length === 2) {
            // 只有 block/element 两个块，隐含表示 page 是 index
            var b = pathList[0], e = pathList[1];
            this.block = b;
            this.element = e;
        }
        else if (pathList.length === 3) {
            // 有 page/block/element，3个块，没有隐含表示
            var p = pathList[0], b = pathList[1], e = pathList[2];
            this.page = p;
            this.block = b;
            this.element = e;
        }
        else if (pathList.length === 4) {
            // 有 site/page/block/element，4个块，没有隐含表示
            var s = pathList[0], p = pathList[1], b = pathList[2], e = pathList[3];
            this.site = s;
            this.page = p;
            this.block = b;
            this.element = e;
        }
        else {
            console.warn('埋点解析错误，path 块长度超出 4 位', path);
            this.inspectionPassed = false;
        }
    };
    class_1.prototype.paserQuery = function (queryBlock) {
        var _this = this;
        var entries = queryBlock.split('&');
        entries.forEach(function (e) {
            var _a = e.split('='), k = _a[0], v = _a[1];
            if (k === 'alive') {
                _this.filterPoint.alive = v;
            }
        });
    };
    class_1.prototype.setName = function () {
        var _a;
        this.name = "".concat(this.site, "_").concat(this.page, "_").concat(this.block, "_").concat(this.element); // 拼接
        if ((_a = this.name) === null || _a === void 0 ? void 0 : _a.includes('-')) {
            console.warn('埋点解析警告：本次埋点包含 "-"，表示某项信息没有补全', this.name);
        }
    };
    return class_1;
}());
export default LogModel;
//# sourceMappingURL=log-model.js.map